import { createRouter, createWebHistory } from 'vue-router';
import Dashboard from '../views/Dashboard.vue';
import Clients from '../views/Clients.vue';
import SalesList from '../views/SalesList.vue';
import NewSale from '../views/NewSale.vue';
import Inventory from '../views/Inventory.vue';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: Dashboard,
    },
    {
      path: '/clients',
      component: Clients,
    },
    {
      path: '/sales',
      component: SalesList,
    },
    {
      path: '/sales/new',
      component: NewSale,
    },
    {
      path: '/sales/edit/:id',
      component: NewSale,
    },
    {
      path: '/inventory',
      component: Inventory,
    },
  ],
});
